import type { components } from 'wg-api-sdk';

import OtherRecommendation from './OtherRecommendation';
import SalesRecommendation from './SalesRecommendation';

type Props = {
  recommendations: Maybe<
    Array<components['schemas']['OnesuranceRecommendation']>
  >;
};

export default function RecommendationContent({ recommendations }: Props) {
  const churnRecommendation = recommendations?.find(
    (recommendation) => recommendation.type === 'CHURN',
  );
  const salesRecommendation = recommendations?.find(
    (recommendation) => recommendation.type === 'SALES',
  );

  return (
    <div className="flex flex-col">
      {churnRecommendation && (
        <div className="relative flex flex-col gap-4 border-b px-2 py-2.5">
          <span
            id={`onesurance-${churnRecommendation.type.toLowerCase()}`}
            className="absolute -top-2"
          />

          <div className="flex flex-col gap-1">
            <OtherRecommendation recommendation={churnRecommendation} />
          </div>
        </div>
      )}

      {salesRecommendation && (
        <div className="relative flex flex-col gap-4 border-b px-2 py-2.5">
          <span
            id={`onesurance-${salesRecommendation.type.toLowerCase()}`}
            className="absolute -top-2"
          />

          <div className="flex flex-col gap-1">
            <SalesRecommendation recommendation={salesRecommendation} />
          </div>
        </div>
      )}
    </div>
  );
}
